// Pure zoom math, mirroring the legacy main.js zoom widget. Kept in app-web
// (canvas-specific, like grid.ts). The store holds the zoom index; the scale is
// derived from it.

export const SCALE_VALUES = [0.5, 0.75, 1, 1.25, 1.5] as const;
export const DEFAULT_ZOOM_IDX = 2; // 100%

// Clamp any input to a valid index, matching the legacy setZoom clamp.
export function clampZoomIdx(idx: number): number {
  return Math.max(0, Math.min(SCALE_VALUES.length - 1, Math.round(idx)));
}

export function scaleForIdx(idx: number): number {
  return SCALE_VALUES[clampZoomIdx(idx)] ?? 1;
}
